export const SOURCE_SITE = 'app.comparacorsi.it';
export const TRACKING_COOKIE = 'cc_tracking_id';
export const FIRST_TOUCH_KEY = 'cc_first_touch';
export const LAST_TOUCH_KEY = 'cc_last_touch';
export const COOKIE_MAX_AGE_DAYS = 365;

export const ATTRIBUTION_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_adset',
  'utm_ad',
  'gclid',
  'fbclid',
  'msclkid',
  'ttclid',
  'li_fat_id',
];
